/**
 * Module to ajaxify all add to cart forms on the page.
 *
 * Copyright (c) 2015 Caroline Schnapp (11heavens.com)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 */
Shopify.AjaxifyCart = (function ($) {
  // Some configuration options.
  // I have separated what you will never need to change from what
  // you might change.

  var _config = {
    // What you might want to change
    addToCartBtnLabel: "Add to cart",
    addedToCartBtnLabel: "Thank you!",
    addingToCartBtnLabel: "Adding...",
    soldOutBtnLabel: "Sold Out",
    howLongTillBtnReturnsToNormal: 2000, // in milliseconds.
    cartCountSelector:
      ".cart-count, #cart-count a:first, #gocart p a, #cart .checkout em, .item-count",
    cartTotalSelector: "#cart-price",
    //Dewey's custom cart icon selector
    cartIconSelector: "#cartTotal",
    emptyCartIconClass: "cartToggle--empty",
    // Cart count display options
    cartCountDisplay: true, // Set to false to disable count display
    cartCountSelector: "#cart-count-display", // CSS selector for count display element
    // 'aboveForm' for top of add to cart form,
    // 'belowForm' for below the add to cart form, and
    // 'nextButton' for next to add to cart button.
    feedbackPosition: "nextButton",

    // What you will never need to change
    //Dewey's custom form selector - collection page only
    collectionGrid: ".collectionGrid", //container for dynamically loaded grid items with add to cart button
    addToCartBtnSelector: '[type="submit"]',
    addToCartFormSelector: '.deweys-product-grid > form[action="/cart/add"]',
    shopifyAjaxAddURL: "/cart/add.js",
    shopifyAjaxCartURL: "/cart.js",
  }

  // Function to update cart icon visibility based on cart state
  var updateCartIconVisibility = function (cart) {
    // Find the cart icon container
    var $cartIcon = $('#cart-icon');
    
    if (cart && cart.item_count > 0) {
      // Cart has items - update cart count display
      if (_config.cartCountDisplay) {
        updateCartCountDisplay(cart.item_count);
      }
    } else {
      // Cart is empty - hide the badges
      $('#cart-count-badge').hide();
      $('#cart-count-badge-mobile').hide();
      
      // Hide cart count display
      if (_config.cartCountDisplay) {
        updateCartCountDisplay(0);
      }
    }
  }

  // Function to update cart count display
  var updateCartCountDisplay = function (count) {
    var $countDisplay = $(_config.cartCountSelector);
    
    if ($countDisplay.length > 0) {
      // Update existing count display
      $countDisplay.text(count);
      if (count > 0) {
        $countDisplay.show();
      } else {
        $countDisplay.hide();
      }
    } else {
      // Create badges for both desktop and mobile cart icons
      var $cartIcon = $('#cart-icon');
      var $cartIconMobile = $('#cart-icon-mobile');
      
      // Handle desktop cart icon
      if ($cartIcon.length > 0) {
        var $countBadge = $('#cart-count-badge');
        if ($countBadge.length === 0) {
          // Create a circular badge positioned near the cart icon
          var $badge = $('<div id="cart-count-badge" style="position: absolute; background: #8eb9ca; color: #333333; border-radius: 50%; width: 24px; height: 24px; display: flex; align-items: center; justify-content: center; font-size: 12px; font-weight: bold; z-index: 1000; top: -12px; right: -7px; border: 2px solid white; box-shadow: 0 2px 4px rgba(0,0,0,0.2);"></div>');
          
          // Position it relative to the cart icon container
          $cartIcon.css('position', 'relative');
          $cartIcon.append($badge);
        }
        
        // Update the count
        $('#cart-count-badge').text(count);
        if (count > 0) {
          $('#cart-count-badge').show();
        } else {
          $('#cart-count-badge').hide();
        }
      }
      
      // Handle mobile cart icon
      if ($cartIconMobile.length > 0) {
        var $countBadgeMobile = $('#cart-count-badge-mobile');
        if ($countBadgeMobile.length === 0) {
          // Create a circular badge positioned near the mobile cart icon
          var $badgeMobile = $('<div id="cart-count-badge-mobile" style="position: absolute; background: #8eb9ca; color: #333333; border-radius: 50%; width: 24px; height: 24px; display: flex; align-items: center; justify-content: center; font-size: 12px; font-weight: bold; z-index: 1000; top: -12px; right: 2px; border: 2px solid white; box-shadow: 0 2px 4px rgba(0,0,0,0.2);"></div>');
          
          // Position it relative to the mobile cart icon container
          $cartIconMobile.css('position', 'relative');
          $cartIconMobile.append($badgeMobile);
        }
        
        // Update the mobile count
        $('#cart-count-badge-mobile').text(count);
        if (count > 0) {
          $('#cart-count-badge-mobile').show();
        } else {
          $('#cart-count-badge-mobile').hide();
        }
      }
    }
  }

  // Rate limiting for cart requests
  var lastCartRequest = 0;
  var cartRequestThrottle = 2000; // Minimum 2 seconds between requests
  
  // Function to refresh cart state (useful for cart removal operations)
  var refreshCartState = function () {
    var now = Date.now();
    if (now - lastCartRequest < cartRequestThrottle) {
      // Too soon since last request, skip this one
      return;
    }
    
    lastCartRequest = now;
    
    $.getJSON(_config.shopifyAjaxCartURL, function (cart) {
      updateCartIconVisibility(cart);
      $(document).trigger('cart:updated', [cart]);
    }).catch(function (xhrOrError) {
      // Handle 429 errors gracefully (xhr from jQuery, or error from native Promise)
      var status = xhrOrError && (xhrOrError.status || xhrOrError.response && xhrOrError.response.status);
      if (status === 429) {
        console.warn('Cart request rate limited, backing off...');
        cartRequestThrottle = 5000;
        setTimeout(function () {
          cartRequestThrottle = 2000; // Reset to normal after 10 seconds
        }, 10000);
      }
    });
  }

  // We need some feedback when adding an item to the cart.
  // Here it is.
  var _showFeedback = function (success, html, $addToCartForm) {
    $(".ajaxified-cart-feedback").remove()
    var feedback =
      '<p class="ajaxified-cart-feedback ' + success + '">' + html + "</p>"
    switch (_config.feedbackPosition) {
      case "aboveForm":
        $addToCartForm.before(feedback)
        break
      case "belowForm":
        $addToCartForm.after(feedback)
        break
      case "nextButton":
      default:
        $addToCartForm.find(_config.addToCartBtnSelector).after(feedback)
        break
    }
    // If you use animate.css
    // $('.ajaxified-cart-feedback').addClass('animated bounceInDown');
    $(".ajaxified-cart-feedback").slideDown()
  }
  var _setText = function ($button, label) {
    if ($button.children().length) {
      $button.children().each(function () {
        if ($.trim($(this).text()) !== "") {
          $(this).text(label)
        }
      })
    } else {
      // Fix: Use .val() for input buttons, .text() for button elements
      if ($button.is('input')) {
        $button.val(label)
      } else {
        $button.text(label)
      }
    }
  }

  // Function to increment quantity of existing cart item
  var _incrementExistingCartItem = function ($addToCartForm, $addToCartBtn, itemId) {
    // Disable button and show loading state
    _setText($addToCartBtn, _config.addingToCartBtnLabel);
    $addToCartBtn.addClass("disabled").prop("disabled", true);
    
    // Mark form as having pending request
    $addToCartForm.data('ajax-request-pending', true);
    
    // First, get current cart to find the item and its current quantity
    $.getJSON(_config.shopifyAjaxCartURL, function (cart) {
      var existingItem = null;
      var newQuantity = 1; // Default quantity to add
      
      // Find the existing item in cart - convert both to numbers for comparison
      if (cart.items && cart.items.length > 0) {
        for (var i = 0; i < cart.items.length; i++) {
          if (parseInt(cart.items[i].variant_id) === parseInt(itemId)) {
            existingItem = cart.items[i];
            newQuantity = existingItem.quantity + 1;
            break;
          }
        }
      }
      
      if (existingItem) {
        // Item exists - update its quantity
        var updateData = {};
        updateData[existingItem.key] = newQuantity;
        
        $.ajax({
          url: '/cart/update.js',
          dataType: "json",
          type: "post",
          data: {
            updates: updateData
          },
          success: function (updatedCart) {
            // Clear pending request flag
            $addToCartForm.data('ajax-request-pending', false);
            
            // Re-enable add to cart button
            $addToCartBtn.addClass("inverted");
            _setText($addToCartBtn, _config.addedToCartBtnLabel);
            _showFeedback(
              "success",
              '<i class="fa fa-check"></i> Quantity updated! Now ' + newQuantity + ' in cart. <a href="/cart">View cart</a> or <a href="/collections/all">continue shopping</a>.',
              $addToCartForm
            );
            
            window.setTimeout(function () {
              $addToCartBtn
                .prop("disabled", false)
                .removeClass("disabled")
                .removeClass("inverted");
              _setText($addToCartBtn, _config.addToCartBtnLabel);
              $addToCartBtn.removeAttr('disabled');
            }, _config.howLongTillBtnReturnsToNormal);
            
            // Don't update immediately - let other mechanisms handle the cart update
            // This prevents using the potentially incorrect item_count from Shopify's immediate response
            
            // Trigger a delayed cart refresh to get the correct count
            setTimeout(function() {
              refreshCartState();
            }, 500);

            // open the drawer cart
            var triggerEvent = new CustomEvent('giftship.drawer-cart.trigger');
            document.dispatchEvent(triggerEvent);
          },
          error: function (XMLHttpRequest) {
            // Clear pending request flag
            $addToCartForm.data('ajax-request-pending', false);
            
            // Fallback to regular add to cart if update fails
            _setText($addToCartBtn, _config.addingToCartBtnLabel);
            _regularAddToCart($addToCartForm, $addToCartBtn);
          }
        });
      } else {
        // Item not found in cart - proceed with regular add to cart
        _setText($addToCartBtn, _config.addingToCartBtnLabel);
        _regularAddToCart($addToCartForm, $addToCartBtn);
      }
    }).catch(function (xhrOrError) {
      // If cart fetch fails, proceed with regular add to cart
      $addToCartForm.data('ajax-request-pending', false);
      _setText($addToCartBtn, _config.addingToCartBtnLabel);
      _regularAddToCart($addToCartForm, $addToCartBtn);
    });
  }

  // Function to handle regular add to cart (extracted from main logic)
  var _regularAddToCart = function ($addToCartForm, $addToCartBtn) {
    // Add to cart.
    $.ajax({
      url: _config.shopifyAjaxAddURL,
      dataType: "json",
      type: "post",
      data: $addToCartForm.serialize(),
      success: function (itemData) {
        // Clear pending request flag and record item ID
        $addToCartForm.data('ajax-request-pending', false);
        $addToCartForm.data('last-item-id', $addToCartForm.find('input[name="id"]').val());
        
        // Clear last-item-id for all other forms so they can be clicked again
        $(_config.addToCartFormSelector).not($addToCartForm).removeData('last-item-id');
        // Re-enable add to cart button.
        $addToCartBtn.addClass("inverted")
        _setText($addToCartBtn, _config.addedToCartBtnLabel)
        _showFeedback(
          "success",
          '<i class="fa fa-check"></i> Added to cart! <a href="/cart">View cart</a> or <a href="/collections/all">continue shopping</a>.',
          $addToCartForm
        )
        window.setTimeout(function () {
          $addToCartBtn
            .prop("disabled", false)
            .removeClass("disabled")
            .removeClass("inverted")
          _setText($addToCartBtn, _config.addToCartBtnLabel)
          // Additional safety: ensure button is fully reset
          $addToCartBtn.removeAttr('disabled')
        }, _config.howLongTillBtnReturnsToNormal)
        // Update cart count and show cart link.
        $.getJSON(_config.shopifyAjaxCartURL, function (cart) {
          if (
            _config.cartIconSelector &&
            $(_config.cartIconSelector).length
          ) {
            //found cart icon selector
            $(_config.cartIconSelector).removeClass(
              _config.emptyCartIconClass
            )
          }
          
          // Update cart icon visibility based on cart state
          updateCartIconVisibility(cart);
          
          // Trigger custom cart update event for other components to listen to
          $(document).trigger('cart:updated', [cart]);

          // open the drawer cart
          // this shouldn't be necessary, but easy-bundle app seems to interrupt the standard process
          var triggerEvent = new CustomEvent('giftship.drawer-cart.trigger');
          document.dispatchEvent(triggerEvent);
        })
      },
      error: function (XMLHttpRequest) {
        // Clear pending request flag
        $addToCartForm.data('ajax-request-pending', false);
        
        var response = eval("(" + XMLHttpRequest.responseText + ")")
        response = response.description
        if (response.slice(0, 4) === "All ") {
          _showFeedback(
            "error",
            response.replace("All 1 ", "All "),
            $addToCartForm
          )
          $addToCartBtn.prop("disabled", false)
          _setText($addToCartBtn, _config.soldOutBtnLabel)
          $addToCartBtn.prop("disabled", true)
        } else {
          _showFeedback(
            "error",
            '<i class="fa fa-warning"></i> ' + response,
            $addToCartForm
          )
          $addToCartBtn.prop("disabled", false).removeClass("disabled")
          _setText($addToCartBtn, _config.addToCartBtnLabel)
        }
      }
    });
  }
  var _init = function () {
    $(document).ready(function () {
      // Refresh cart state on page load to update cart count display
      refreshCartState();
      
      // Listen for cart removal events (common Shopify cart events)
      $(document).on('cart:updated', function(event, cart) {
        if (cart) {
          updateCartIconVisibility(cart);
        }
      });
      
      // Listen for cart drawer/removal events
      $(document).on('cart:item:removed', function() {
        refreshCartState();
      });
      
      // Listen for cart quantity change events
      $(document).on('cart:quantity:changed', function() {
        refreshCartState();
      });
      
      // Periodic cart state refresh as fallback (every 15 seconds to reduce server load)
      setInterval(function() {
        refreshCartState();
      }, 15000);
      
      // Watch for changes in cart-related elements (MutationObserver)
      if (window.MutationObserver) {
        var cartObserverTimeout;
        var cartObserver = new MutationObserver(function(mutations) {
          var shouldRefresh = false;
          mutations.forEach(function(mutation) {
            // Check if cart-related elements changed
            if (mutation.target && 
                ((mutation.target.id && mutation.target.id.includes && mutation.target.id.includes('cart')) || 
                 (mutation.target.className && mutation.target.className.includes && mutation.target.className.includes('cart')) ||
                 (mutation.target.classList && mutation.target.classList.contains && mutation.target.classList.contains('cart-item'))
                )) {
              shouldRefresh = true;
            }
          });
          if (shouldRefresh) {
            // Debounce the refresh to prevent excessive requests
            clearTimeout(cartObserverTimeout);
            cartObserverTimeout = setTimeout(function() {
              refreshCartState();
            }, 1000); // Wait 1 second after last mutation before refreshing
          }
        });
        
        // Observe the document body for cart-related changes
        cartObserver.observe(document.body, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['class', 'id']
        });
      }
      
      //$(_config.addToCartFormSelector).submit(function(e) {
      // Remove any existing handlers to prevent duplication
      $(_config.collectionGrid).off("submit", _config.addToCartFormSelector);
      $(_config.collectionGrid).on(
        "submit",
        _config.addToCartFormSelector,
        function (e) {
          e.preventDefault()
          var $addToCartForm = $(this)
          var $addToCartBtn = $addToCartForm.find(_config.addToCartBtnSelector)
          
          // Check if button is already disabled - if so, don't proceed
          if ($addToCartBtn.prop('disabled')) {
            return false;
          }
          
          // Check if there's already a pending request for this form
          if ($addToCartForm.data('ajax-request-pending')) {
            return false;
          }
          
          // Check if this is the same item as the last successful addition for THIS specific form
          var lastItemId = $addToCartForm.data('last-item-id');
          var currentItemId = $addToCartForm.find('input[name="id"]').val();
          
          if (lastItemId === currentItemId) {
            // Same item - increment quantity instead of showing error
            _incrementExistingCartItem($addToCartForm, $addToCartBtn, currentItemId);
            return false;
          }
          
          _setText($addToCartBtn, _config.addingToCartBtnLabel)
          $addToCartBtn.addClass("disabled").prop("disabled", true)
          
          // Mark form as having pending request
          $addToCartForm.data('ajax-request-pending', true);
          
          // Use the extracted regular add to cart function
          _regularAddToCart($addToCartForm, $addToCartBtn);
          
          return false
        }
      )
    })
  }
  return {
    init: function (params) {
      // Configuration
      params = params || {}
      // Merging with defaults.
      $.extend(_config, params)
      // Action
      $(function () {
        _init()
      })
    },
    getConfig: function () {
      return _config
    },
    updateCartIcon: updateCartIconVisibility,
    refreshCart: refreshCartState,
    updateCartCount: updateCartCountDisplay
  }
})(jQuery)

Shopify.AjaxifyCart.init()
